// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1VZPl","col":"Table_col__FEZpf","fulfillmentStatus":"Table_fulfillmentStatus__bqLHw","emailCol":"Table_emailCol__OFj8F"};